// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.1
//   protoc               v3.21.12
// source: confirmtermsofservice.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "confirmtermsofservice";

export interface ConfirmTermsOfServiceRequest {
}

export interface ConfirmTermsOfServiceResponse {
}

function createBaseConfirmTermsOfServiceRequest(): ConfirmTermsOfServiceRequest {
  return {};
}

export const ConfirmTermsOfServiceRequest: MessageFns<ConfirmTermsOfServiceRequest> = {
  encode(_: ConfirmTermsOfServiceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmTermsOfServiceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfirmTermsOfServiceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ConfirmTermsOfServiceRequest {
    return {};
  },

  toJSON(_: ConfirmTermsOfServiceRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfirmTermsOfServiceRequest>, I>>(base?: I): ConfirmTermsOfServiceRequest {
    return ConfirmTermsOfServiceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmTermsOfServiceRequest>, I>>(_: I): ConfirmTermsOfServiceRequest {
    const message = createBaseConfirmTermsOfServiceRequest();
    return message;
  },
};

function createBaseConfirmTermsOfServiceResponse(): ConfirmTermsOfServiceResponse {
  return {};
}

export const ConfirmTermsOfServiceResponse: MessageFns<ConfirmTermsOfServiceResponse> = {
  encode(_: ConfirmTermsOfServiceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmTermsOfServiceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfirmTermsOfServiceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ConfirmTermsOfServiceResponse {
    return {};
  },

  toJSON(_: ConfirmTermsOfServiceResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfirmTermsOfServiceResponse>, I>>(base?: I): ConfirmTermsOfServiceResponse {
    return ConfirmTermsOfServiceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmTermsOfServiceResponse>, I>>(_: I): ConfirmTermsOfServiceResponse {
    const message = createBaseConfirmTermsOfServiceResponse();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
